import type { TimeRange } from '../api/types'

const RANGES: { value: TimeRange; label: string }[] = [
  { value: 'hour', label: 'Hour' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'quarter', label: 'Quarter' },
  { value: 'year', label: 'Year' },
]

/** One row of range presets above the charts, per the interaction spec. */
export function TimeRangePicker({ value, onChange, options }: {
  value: TimeRange
  onChange: (range: TimeRange) => void
  options?: TimeRange[]
}) {
  const shown = options ? RANGES.filter((r) => options.includes(r.value)) : RANGES
  return (
    <div className="segmented" role="group" aria-label="Time range">
      {shown.map((r) => (
        <button
          key={r.value}
          type="button"
          aria-pressed={value === r.value}
          onClick={() => onChange(r.value)}
        >
          {r.label}
        </button>
      ))}
    </div>
  )
}
